import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
export const PickMonthAndYear = ({ setPickValue }) => {
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    setPickValue(selectedDate);
  }, [selectedDate]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };
  return (
    <DatePicker
      className="date_picker_wrapper"
      selected={selectedDate}
      onChange={handleDateChange}
      showMonthYearPicker
      dateFormat="MM/yyyy"
      placeholderText="MM / YYYY"
    />
  );
};
